// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"248":"companyShow","476":"companyCreate","784":"companyEdit"}[chunkId] + "." + {"248":"72549774","476":"72549774","784":"72549774"}[chunkId] + ".css";
};